module.exports = __webpack_public_path__ + "img/grandparent-hold-ipad.f86bd0fc.png";